
import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const BeginnerFAQ = () => {
  const faqs = [
    {
      question: "Hvor gammel skal man være for at starte med klaverundervisning?",
      answer: "Jeg underviser begyndere fra 6 år og opefter. For yngre børn (6-8 år) anbefaler jeg kortere lektioner på 30 minutter for at holde deres koncentration og gøre det sjovt. Der er ingen øvre aldersgrænse – det er aldrig for sent at lære at spille klaver!"
    },
    {
      question: "Skal jeg have et klaver derhjemme for at starte?",
      answer: "Det er en fordel at have et instrument derhjemme, så du kan øve mellem lektionerne. Et digitalt klaver eller keyboard er tilstrækkeligt i begyndelsen. Jeg kan give råd om køb eller leje af instrumenter, der passer til dit budget og behov."
    },
    {
      question: "Hvor ofte skal jeg tage klavertimer som begynder?",
      answer: "For de fleste begyndere anbefaler jeg én ugentlig lektion på 45 minutter. Dette giver dig tid til at fordøje nye koncepter og øve mellem lektionerne, uden at du bliver overvældet. Konsistens er vigtigere end hyppighed i begyndelsen."
    },
    {
      question: "Hvor meget skal jeg øve mellem lektionerne?",
      answer: "For begyndere anbefaler jeg 15-30 minutters øvning 4-5 dage om ugen. Kvaliteten af din øvning er vigtigere end kvantiteten. Jeg giver specifikke øveanvisninger efter hver lektion, så du ved præcis, hvad du skal fokusere på."
    },
    {
      question: "Kan jeg lære at spille klaver som voksen begynder?",
      answer: "Absolut! Mange af mine elever er voksne begyndere. Voksne har ofte en fordel i form af disciplin, målrettethed og evnen til at forstå musikalske koncepter. Jeg tilpasser undervisningen til voksne med relevant repertoire og effektive øvemetoder."
    },
    {
      question: "Hvor lang tid tager det, før jeg kan spille mine yndlingssange?",
      answer: "Allerede efter 2-3 måneder med regelmæssig undervisning og øvning vil de fleste begyndere kunne spille simple versioner af populære sange. Vi kan arbejde med forenklede arrangementer af dine yndlingssange tidligt i forløbet."
    },
    {
      question: "Skal jeg lære at læse noder for at spille klaver?",
      answer: "Nodelæsning er en værdifuld færdighed, der giver dig frihed til at spille al musik, men der findes flere tilgange. I min undervisning introducerer jeg gradvist nodelæsning side om side med at lære at spille efter gehør og akkorder, så du får en alsidig tilgang til musikken."
    }
  ];

  return (
    <section className="py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-serif font-bold mb-4">
              Ofte stillede spørgsmål om klaverundervisning for begyndere
            </h2>
            <p className="text-lg text-gray-600">
              Find svar på de mest almindelige spørgsmål fra nye klaverspillere.
            </p>
          </div>
          
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`}>
                <AccordionTrigger className="text-left font-semibold text-lg">{faq.question}</AccordionTrigger>
                <AccordionContent className="text-gray-600">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
          
          <div className="mt-8 text-center">
            <p className="text-gray-600">
              Har du andre spørgsmål? <a href="/kontakt#top" className="text-piano-gold font-semibold hover:underline">Kontakt mig</a> gerne for mere information.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BeginnerFAQ;
